// 运行的容器环境
export enum IClients {
  miniProgram = 'miniProgram',
  ios = 'ios',
  android = 'android',
  web = 'web',
}
